import { render, staticRenderFns } from "./advanceTestTemplate.vue?vue&type=template&id=47e45518&scoped=true&"
import script from "./advanceTestTemplate.vue?vue&type=script&lang=js&"
export * from "./advanceTestTemplate.vue?vue&type=script&lang=js&"
import style0 from "./advanceTestTemplate.vue?vue&type=style&index=0&id=47e45518&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e45518",
  null
  
)

export default component.exports